import { Box, Card, CardContent, Divider, Skeleton, Stack } from '@mui/material'

const TERM_TILE_MIN_WIDTH = 92
const TERM_TILE_HEIGHT = 64
const TERM_SKELETON_COUNT = 5

const PlanCardSkeleton = () => (
  <Card>
    <CardContent>
      <Stack spacing={2.5}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Stack spacing={0.75}>
            <Skeleton width={170} />
            <Skeleton width={130} height={28} />
          </Stack>
          <Skeleton width={80} height={40} />
        </Stack>
        <Skeleton width="85%" />
        <Divider />
        <Stack direction="row" spacing={4}>
          <Stack spacing={0.5}>
            <Skeleton width={60} />
            <Skeleton width={90} />
          </Stack>
          <Stack spacing={0.5}>
            <Skeleton width={40} />
            <Skeleton width={90} />
          </Stack>
        </Stack>
        <Stack spacing={1}>
          <Skeleton width={120} />
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: `repeat(auto-fill, minmax(${TERM_TILE_MIN_WIDTH}px, 1fr))`,
              gap: 1.5,
            }}
          >
            {Array.from({ length: TERM_SKELETON_COUNT }).map((_, index) => (
              <Skeleton key={index} variant="rounded" height={TERM_TILE_HEIGHT} />
            ))}
          </Box>
        </Stack>
      </Stack>
    </CardContent>
  </Card>
)

export const CustomBuydownSkeleton = () => (
  <Box>
    <Stack spacing={0.5} sx={{ mb: 3 }}>
      <Skeleton width={320} height={32} />
      <Skeleton width={460} />
    </Stack>
    <Stack spacing={2}>
      <Skeleton width={280} height={28} />
      <PlanCardSkeleton />
    </Stack>
  </Box>
)
